import React from 'react';
import ReactDOM from 'react-dom';
import BlogCategoryLanding from '../../components/blog/BlogCategoryLanding.jsx';
import BlogHomePage from '../../components/blog/BlogHomePage.jsx';

document.addEventListener('DOMContentLoaded', function (event) {
    const blogListContent = document.getElementById('bloglistcontent');
    if (blogListContent !== null && blogListContent !== undefined) {
        ReactDOM.render(
            <BlogHomePage {...blogListContent.dataset} />,
            blogListContent
        );
    }
    const blogListContentCategory = document.getElementById(
        'bloglistcontentcategory'
    );
    if (
        blogListContentCategory !== null &&
        blogListContentCategory !== undefined
    ) {
        ReactDOM.render(
            <BlogCategoryLanding {...blogListContentCategory.dataset} />,
            blogListContentCategory
        );
    }
});
